module.exports = __webpack_public_path__ + "static/pharmacodb-logo-dc030ae117a9626b00adcbff844df074.png";